import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  ProductGridSetting,
  buttonThemeUuid,
  display2ndCurrencyPrice,
  displayProductDescription,
  displayProductPromotionTag,
  displayProductReview,
  displayRRP,
  gridSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage-revamp/constant';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
//import { get } from 'lodash';
import { OriCheckbox, OriSelect } from 'src/components/Antd';
import { gridSettingFields } from '../fields';
import { getEditableStatus } from '../util';

const P = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled, options } = props;

  return (
    <Wrapper id={ProductGridSetting} breakpoint={breakpoint}>
      <BlockTitle
        id={ProductGridSetting}
        title={getI18n('salesChannelContent.index.productGridSetting')}
        breakpoint={breakpoint}
        onReset={() =>
          props.handleOnSectionReset(gridSettingFields, breakpoint)
        }
        onCopy={() => props.handleOnSectionCopy(gridSettingFields, breakpoint)}
        headerErrorDependencies={[]}
        validator={() => {
          return;
        }}
      />
      <Field shouldUpdate>
        {(props, meta, { getFieldValue }) => {
          const is_editable = getEditableStatus(
            getFieldValue,
            ProductGridSetting,
            breakpoint,
          );
          return (
            <>
              <Section size='small' bottomBorder style={{ paddingTop: 0 }}>
                <ItemWrapper
                  title={`“${getI18n(
                    'salesChannelContent.index.addtoCart',
                  )}” ${getI18n('salesChannelContent.index.buttonTheme')}`}>
                  <Field
                    name={[gridSetting, buttonThemeUuid]}
                    initialValue={null}>
                    <OriSelect
                      disabled={disabled || !is_editable}
                      size='large'
                      //   value={moduleWidth}
                      //   onChange={handleOnModuleWidthChange}
                    >
                      <OriSelect.Option value={null}>
                        {getI18n('general.status.none')}
                      </OriSelect.Option>
                      {(options || []).map((i) => {
                        const { label, value } = i;
                        return (
                          <OriSelect.Option value={value} key={value}>
                            {label}
                          </OriSelect.Option>
                        );
                      })}
                    </OriSelect>
                  </Field>
                </ItemWrapper>
              </Section>
              <Section size='small' bottomBorder>
                <Field
                  name={[gridSetting, displayProductDescription]}
                  valuePropName={'checked'}>
                  {(props, meta) => {
                    return (
                      <OriCheckbox
                        disabled={disabled || !is_editable}
                        className={css.checkboxContainer}
                        {...props}
                        {...meta}>
                        <span>
                          {getI18n(
                            'salesChannelContent.index.displayproductdescription',
                          )}
                        </span>
                      </OriCheckbox>
                    );
                  }}
                </Field>
                <Field
                  name={[gridSetting, displayRRP]}
                  valuePropName={'checked'}>
                  {(props, meta) => {
                    return (
                      <OriCheckbox
                        disabled={disabled || !is_editable}
                        className={css.checkboxContainer}
                        {...props}
                        {...meta}>
                        <span>
                          {getI18n('salesChannelContent.index.displayRRP')}
                        </span>
                      </OriCheckbox>
                    );
                  }}
                </Field>
                <Field
                  name={[gridSetting, display2ndCurrencyPrice]}
                  valuePropName={'checked'}>
                  {(props, meta) => {
                    return (
                      <OriCheckbox
                        disabled={disabled || !is_editable}
                        className={css.checkboxContainer}
                        {...props}
                        {...meta}>
                        <span>
                          {getI18n(
                            'salesChannelContent.index.displaysecondarycurrencyprice',
                          )}
                        </span>
                      </OriCheckbox>
                    );
                  }}
                </Field>
                <Field
                  name={[gridSetting, displayProductReview]}
                  valuePropName={'checked'}>
                  {(props, meta) => {
                    return (
                      <OriCheckbox
                        disabled={disabled || !is_editable}
                        className={css.checkboxContainer}
                        {...props}
                        {...meta}>
                        <span>
                          {getI18n(
                            'salesChannelContent.index.displayproductreview',
                          )}
                        </span>
                      </OriCheckbox>
                    );
                  }}
                </Field>
                <Field
                  name={[gridSetting, displayProductPromotionTag]}
                  valuePropName={'checked'}>
                  {(props, meta) => {
                    return (
                      <OriCheckbox
                        disabled={disabled || !is_editable}
                        className={css.checkboxLast}
                        {...props}
                        {...meta}>
                        <span>
                          {getI18n(
                            'salesChannelContent.index.displayproductpromotiontag',
                          )}
                        </span>
                      </OriCheckbox>
                    );
                  }}
                </Field>
              </Section>
            </>
          );
        }}
      </Field>
    </Wrapper>
  );
};
export default P;
